// First import on purpose: captures an /auth/callback error from the URL before anything else loads.
import './lib/authRedirectError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import App from './App';
import './index.css';

// ── PostHog analytics ────────────────────────────────────────────────────────
// Guarded by env var so the app works fine without a key (local dev, CI, etc.)
// Keep nothing on the device: no cookie or localStorage id (persistence: 'memory'), so no
// consent banner is needed. Clear the id older builds left behind.
try {
  Object.keys(localStorage).filter((k) => /^ph_.*_posthog$/.test(k)).forEach((k) => localStorage.removeItem(k));
} catch (_) { /* storage blocked */ }

if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview:  true,
    capture_pageleave: true,
    autocapture:       false,
    // Session replay stays off in code: it can't be switched on from the PostHog dashboard
    // without a consent flow shipping first.
    disable_session_recording: true,
    persistence:       'memory',
    disable_surveys:   true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
